import { PaymentMethodCode, type PaymentOption } from '@src/domains/payments/types/payment';

const VALID_PAYMENT_METHOD_CODES = new Set<PaymentMethodCode>([
  PaymentMethodCode.CreditCard,
  PaymentMethodCode.DebitCard,
  PaymentMethodCode.Pix,
]);

export const filterValidPaymentMethods = (options: PaymentOption[]): PaymentOption[] =>
  options.filter((opt) => VALID_PAYMENT_METHOD_CODES.has(opt.paymentMethod.code));
